import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    value?: string;
    scratched?: boolean;
    className?: string;
};

const Selection = ({ value, scratched, className }: Props) => {
    const { t } = useTranslation('kol');
    if (value) {
        return (
            <div
                className={classNames(
                    'text-[#000] font-bold text-[13px] break-words w-full mb-1',
                    {
                        // 'text-[#CCCCCC]': scratched,
                    },
                    className
                )}
            >
                {value} {scratched && `(${t('betpick.scratched')})`}
            </div>
        );
    } else {
        return <></>;
    }
};

export default Selection;
